import * as types from "./types";

/*conversations*/
export const fetchingConversations = () => ({
  type: types.FETCHING_CONVERSATIONS,
  loading: true
});
export const fetchedConversations = conversations => ({
  type: types.FETCHED_CONVERSATIONS,
  loading: false,
  conversations: conversations
});

export const errorFetchingConversations = error => ({
  type: types.ERROR_FETCHING_CONVERSATIONS,
  error: error,
  loading: false
});

/*message*/
export const fetchingMessages = conversation_guid => ({
  type: types.FETCHING_MESSAGES,
  conversation_guid: conversation_guid,
  loading: true
});

export const fetchedMessages = (conversation_guid, messages, has_more, last_evaluated_key) => ({
  type: types.FETCHED_MESSAGES,
  loading: false,
  messages: messages,
  conversation_guid: conversation_guid,
  has_more: has_more,
  last_evaluated_key: last_evaluated_key
});

export const errorFetchingMessages = (conversation_guid, error) => ({
  type: types.ERROR_FETCHING_MESSAGES,
  conversation_guid: conversation_guid,
  error: error,
  loading: false
});

/* send message*/
export const sendingMessage = conversation_guid => ({
  type: types.SENDING_MESSAGE,
  conversation_guid: conversation_guid,
  loading: true
});
export const sentMessage = conversation_guid => ({
  type: types.SENT_MESSAGE,
  loading: false,
  conversation_guid: conversation_guid
});
export const errorSendingMessage = error => ({
  type: types.ERROR_SENDING_MESSAGE,
  error: error,
  loading: false
});

/* create conversation */
export const creatingConversation = receiver_guid => ({
  type: types.CREATING_CONVERSATION,
  receiver_guid: receiver_guid,
  loading: true
});

export const createdConversation = receiver_guid => ({
  type: types.CREATED_CONVERSATION,
  receiver_guid: receiver_guid,
  loading: false
});

export const errorCreatingConversation = (receiver_guid, error) => ({
  type: types.ERROR_CREATING_CONVERSATION,
  receiver_guid: receiver_guid,
  error: error,
  loading: false
});

export const fetchingConversationMembers = () => ({
  type: types.FETCHING_CONVERSATION_MEMBERS,
  loading: true
});

export const fetchedConversationMembers = conversation_members => ({
  type: types.FETCHED_CONVERSATION_MEMBERS,
  conversation_members: conversation_members,
  loading: false
});

export const errorFetchingConversationMembers = error => ({
  type: types.ERROR_FETCHING_CONVERSATION_MEMBERS,
  error: error,
  loading: false
});
